import { WebStorageStateStore } from 'oidc-client-ts';
import type { AuthProviderProps } from 'react-oidc-context';
import { config } from '../config';

export const oidcConfig: AuthProviderProps = {
  authority: config.oidcAuthority,
  client_id: config.oidcClientId,
  redirect_uri: `${window.location.origin}/callback`,
  post_logout_redirect_uri: window.location.origin,
  response_type: 'code',
  scope: 'openid profile email',
  // renew via the refresh token in the background; renew failures are handled
  // by RequireAuth (re-auth, never an error screen). The check-session iframe
  // is disabled to avoid Keycloak "Session doesn't have required client" noise.
  automaticSilentRenew: true,
  monitorSession: false,
  accessTokenExpiringNotificationTimeInSeconds: 60,
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
  onSigninCallback: () => {
    // Full navigation back to the pre-login location: the router must leave
    // the /callback route (history.replaceState alone would not re-route).
    const returnTo = sessionStorage.getItem('usc:returnTo') ?? '/';
    sessionStorage.removeItem('usc:returnTo');
    window.location.replace(returnTo);
  },
};
